/**
 * CodeSystem próprio da teleconsultoria.
 * Não reutiliza o code pronto-atendimento.
 */
export const TELECONSULTORIA_SERVICE_CATEGORY = {
  system: "https://fluxmed.com.br/fhir/CodeSystem/teleconsultoria",
  code: "teleconsultoria",
  display: "Teleconsultoria",
} as const;

/** Token de busca FHIR: system|code */
export const TELECONSULTORIA_SERVICE_CATEGORY_TOKEN = `${TELECONSULTORIA_SERVICE_CATEGORY.system}|${TELECONSULTORIA_SERVICE_CATEGORY.code}`;

/**
 * participant.type do convidado (Appointment e Encounter).
 * Separa o teleconsultor do host sem depender da ordem do array.
 */
export const TELECONSULTORIA_PARTICIPANT_TYPE = {
  system: "http://terminology.hl7.org/CodeSystem/v3-ParticipationType",
  code: "CON",
  display: "consultant",
} as const;

/**
 * Erro lançado quando a evolução já tem outro teleconsultor.
 * Regra: no máximo 1 teleconsultor por evolução.
 */
export const TELECONSULTORIA_GUEST_ALREADY_INVITED =
  "Esta evolução já tem um teleconsultor convidado.";

/** Erro lançado quando já existe convite (Task) aguardando resposta. */
export const TELECONSULTORIA_INVITE_PENDING =
  "Já existe um convite de teleconsultoria aguardando resposta.";

/** Valor pronto para participant.type. */
export function teleconsultoriaParticipantType() {
  return [{ coding: [{ ...TELECONSULTORIA_PARTICIPANT_TYPE }] }];
}
